import { faRightFromBracket } from "@fortawesome/duotone-light-svg-icons"
import { FontAwesomeIcon } from "@fortawesome/react-fontawesome"
import { JoonUIColor, Typography } from "@joonapp/web-shared"
import { useTranslation } from "react-i18next"

import { useAuth } from "../../util/auth"

const LogoutButton = () => {
  const { signout } = useAuth()
  const { t } = useTranslation()

  return (
    <button onClick={signout}>
      <div
        className={`flex items-center justify-center gap-2 bg-white border border-destructive rounded-md min-h-9 h-9 w-full max-w-[300px] mx-auto`}
      >
        <FontAwesomeIcon
          icon={faRightFromBracket}
          color={JoonUIColor.semantic.destructive}
        />
        <Typography variant="body" color={JoonUIColor.semantic.destructive}>
          {t("LOGOUT")}
        </Typography>
      </div>
    </button>
  )
}

export default LogoutButton
